package com.vizio.redwolf.auth.model

import com.vizio.redwolf.utils.HttpRequestInfo
import io.ktor.client.statement.HttpResponse
import io.ktor.client.statement.bodyAsText
import io.ktor.client.statement.request
import io.ktor.http.Headers
import io.ktor.http.HttpMethod
import io.ktor.http.HttpStatusCode
import io.ktor.http.Url
import io.ktor.http.content.TextContent

data class HttpInfo(
    val url: Url,
    val method: HttpMethod,
    val requestHeaders: Headers,
    val requestBody: String? = null,
    val responseHeaders: Headers? = null,
    val responseStatusCode: HttpStatusCode? = null,
    val responseBody: String? = null
)

fun HttpRequestInfo.buildHttpInfo(): HttpInfo? {
    return try {
        HttpInfo(
            url = Url(this.url),
            method = HttpMethod(this.method),
            requestHeaders = Headers.build { requestHeaders },
            requestBody = this.requestBody
        )
    } catch (ex: Exception) {
        ex.printStackTrace()
        null
    }
}

suspend fun HttpResponse.buildHttpInfo(): HttpInfo? {
    return try {
        HttpInfo(
            url = request.url,
            method = request.method,
            requestHeaders = request.headers,
            requestBody = (request.content as? TextContent)?.text,
            responseHeaders = this.headers,
            responseStatusCode = this.status,
            responseBody = this.bodyAsText()
        )
    } catch (ex: Exception) {
        ex.printStackTrace()
        null
    }
}
